import React, { FunctionComponent } from 'react';

import { PropertyTextInput } from '@paragon/client-tools';

import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { useAppSelector } from '../../../hooks';

export const BracedMember: FunctionComponent<{ bracedMemberGuid: string }> = ({ bracedMemberGuid }) => {
  const componentDesign = useAppSelector(getActiveComponentDesign)!;
  const bracedMemberName = componentDesign.component.members.find(({ guid }) => guid === bracedMemberGuid)?.name ?? '';

  return <PropertyTextInput sx={{ m: 1 }} value={bracedMemberName} property="Braced Member" disabled />;
};
